(() => {
  const key = 'ws-cooler-gift-dismissed';
  const norm = value => value.toLowerCase().replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
  const football = {'baltimore':'ravens','buffalo':'bills','carolina':'panthers','chicago':'bears','cincinnati':'bengals','cleveland':'browns','dallas':'cowboys','denver':'broncos','detroit':'lions','green bay':'packers','houston':'texans','indianapolis':'colts indy','jacksonville':'jaguars jags','kansas city':'chiefs kc','las vegas':'raiders vegas','los angeles':'rams la','minnesota':'vikings','new england':'patriots pats','new york blue':'giants ny','new york green':'jets ny','philadelphia':'eagles philly birds','pittsburgh':'steelers','san francisco':'49ers niners sf','seattle':'seahawks','tampa bay':'buccaneers bucs','tennessee':'titans','washington':'commanders'};
  const baseball = {'philadelphia':'phillies philly','houston':'astros','san francisco':'giants sf','st louis':'cardinals saint louis cards'};
  const college = {'michigan':'wolverines','texas a m':'aggies tamu texas am','oklahoma':'sooners ou','nebraska':'cornhuskers huskers','lsu':'tigers louisiana state university'};
  const teamTerms = item => {
    const variant=norm(item.variant), title=norm(item.title);
    const league=title.includes('baseball') ? baseball : title.includes('ncaa') || variant==='lsu' ? college : football;
    const entries=Object.entries(league).filter(([city])=>variant.includes(city));
    return norm([variant,title,...entries.map(([city,names])=>city+' '+names)].join(' ')).split(' ');
  };
  const matchesTeam = (item, search) => norm(search).split(' ').filter(Boolean).every(word=>teamTerms(item).some(term=>term.startsWith(word)));
  const sportsRank = item => {
    const name = norm(item.variant+' '+item.title);
    const priority = ['buffalo','philadelphia','green bay','chicago'];
    const city = priority.findIndex(value => name.includes(value));
    if (city !== -1) return city;
    if (name.includes('ncaa') || [8770952462518,8792688132278].includes(item.productId)) return 4;
    return 5;
  };
  class CoolerGiftOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        const state = JSON.parse(this.querySelector('[data-gift-state]').textContent);
        this.cart = state.cart;
        this.t = state.strings;
        this.catalog = JSON.parse(document.getElementById('ws-gift-catalog').textContent);
        this.currency = this.cart.currency || 'USD';
        this.group = 'originals';
        this.eligibleIds = new Set([8811876417718,8807313408182,8770952233142,8792714903734,8770952462518,8792688132278,8784458449078,8783757967542,8770951577782,8832843612342]);
        this.addEventListener('click', e => this.handleClick(e));
        this.querySelector('[data-gift-search]').addEventListener('input', () => this.renderCards());
        this.querySelector('[data-gift-format]').addEventListener('change', () => this.renderCards());
        this.renderChug();
        this.renderSummary();
        this.renderCards();
        try {if (sessionStorage.getItem(key) === 'yes' && !this.hasCooler()) this.collapse(true);} catch (_) {}
      } catch (error) {
        this.querySelector('[data-gift-error]').textContent = this.t?.catalog_error || 'Gift ideas could not load. Your cart is ready below.';
      }
    }
    money(cents) {return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.currency}).format(cents / 100);}
    node(tag, cls, text) {const el = document.createElement(tag); if(cls) el.className = cls; if(text !== undefined) el.textContent = text; return el;}
    hasCooler() {return this.cart.items.some(item => this.eligibleIds.has(item.product_id));}
    discount(cents) {return Math.floor(cents * .2);}
    chugOriginal() {return this.cart.items.filter(i=>i.product_id===7799476617398).reduce((sum,i)=>sum+i.original_line_price,0);}
    chugSaving() {return this.cart.items.filter(i=>i.product_id===7799476617398).reduce((sum,i)=>sum+this.discount(i.original_price)*i.quantity,0);}
    eligible(item) {return item.product_id === 7799476617398 || this.eligibleIds.has(item.product_id);}
    totals(extra = 0) {
      const regular = this.cart.original_total_price + extra;
      const saving = extra > 0
        ? this.cart.items.filter(i=>this.eligible(i)).reduce((sum,i)=>sum+this.discount(i.original_price)*i.quantity,0)+this.discount(extra)
        : this.cart.original_total_price-this.cart.total_price;
      return {regular,saving,total:regular-saving};
    }
    priceLine(label, regular, saving) {
      const row=this.node('div','ws-gift__price-line');
      if(label)row.append(this.node('span','ws-gift__price-label',label));
      const prices=this.node('span','ws-gift__prices');
      const old=this.node('s','',this.money(regular));old.setAttribute('aria-label',this.t.was+' '+this.money(regular));
      const now=this.node('strong','',this.money(regular-saving));now.setAttribute('aria-label',this.t.offer_price+' '+this.money(regular-saving));
      if(saving>0)prices.append(old);prices.append(now);row.append(prices);return row;
    }
    renderChug() {
      const box=this.querySelector('[data-gift-chug]');box.replaceChildren();
      box.hidden=this.hasCooler();
      box.append(this.node('p','ws-gift__unlock',this.t.unlock),this.priceLine(this.t.chug,this.chugOriginal(),this.chugSaving()),this.node('p','ws-gift__item-saving',this.t.chug_saving+': '+this.money(this.chugSaving())+' · '+this.t.twenty_off));
    }
    renderSummary() {
      const summary = this.querySelector('[data-gift-summary]');
      summary.hidden = !this.hasCooler();
      this.querySelector('[data-gift-picker]').hidden = this.hasCooler();
      if (!this.hasCooler()) return;
      this.querySelector('[data-gift-dismiss]').textContent = this.t.back;
      this.querySelector('.ws-gift__title').textContent = this.t.summary;
      summary.replaceChildren();
      const totals = this.totals();
      for(const item of this.cart.items) {
        const saving=item.original_line_price-item.final_line_price;
        const title=item.product_title || item.title;
        const variant=item.variant_title && item.variant_title!=='Default Title' ? ' · '+item.variant_title : '';
        summary.append(this.priceLine(title+variant+(item.quantity>1?' × '+item.quantity:''),item.original_line_price,saving));
        if(saving)summary.append(this.node('p','ws-gift__item-saving',this.t.save+' '+this.money(saving)));
      }
      for(const [label,value] of [[this.t.regular,totals.regular],[this.t.saving,-totals.saving],[this.t.total,totals.total]]) {
        const row=this.node('div','ws-gift__summary-row');row.append(this.node('span','',label),this.node('strong','',this.money(value)));summary.append(row);
      }
      summary.append(this.node('p','ws-gift__fine',this.t.not_applied));
      const more=this.node('button','ws-gift__more',this.t.more);more.type='button';more.dataset.giftMore='';summary.append(more);
    }
    cardTitle(item) {
      if(item.group==='teams') return `${item.variant.replace(' - Patricia Allen Fund x Zubaz','')}${item.title.toLowerCase().includes('baseball') && !item.variant.toLowerCase().includes('baseball') ? ' Baseball' : ''} ${this.t[item.format]}`;
      return item.title.replace('Varsity Cooler ','')+(item.variant==='Default Title'?'':` · ${item.variant}`);
    }
    renderCards() {
      this.querySelector('[data-gift-filters]').hidden = this.group !== 'teams';
      this.querySelector('[data-gift-hint]').textContent = this.t[this.group+'_hint'];
      const search = norm(this.querySelector('[data-gift-search]').value);
      const format = this.querySelector('[data-gift-format]').value;
      const items = this.catalog.filter(p=>p.group===this.group).filter(p=>this.group!=='teams' || ((format==='all'||p.format===format)&&matchesTeam(p,search)));
      if(this.group==='teams')items.sort((a,b)=>sportsRank(a)-sportsRank(b));
      const grid=this.querySelector('[data-gift-grid]');grid.replaceChildren();
      if(!items.length) {grid.append(this.node('p','ws-gift__empty',this.t.empty));return;}
      items.forEach(item=>{
        const card=this.node('article','ws-gift__card');
        const picture=this.node('img','ws-gift__image');picture.src=item.image;picture.alt=this.cardTitle(item);picture.width=180;picture.height=160;picture.loading='lazy';
        card.append(picture,this.node('h4','ws-gift__name',this.cardTitle(item)));
        const giftSaving=this.discount(item.price), chugSaving=this.chugSaving();
        card.append(this.priceLine('',item.price,giftSaving));
        card.append(this.node('p','ws-gift__item-saving',this.t.twenty_off));
        const totals=this.totals(item.price);
        card.append(this.node('p','ws-gift__breakdown',this.t.gift_saving+': '+this.money(giftSaving)));
        card.append(this.node('p','ws-gift__breakdown',this.t.chug_saving+': '+this.money(chugSaving)));
        const otherSavings=totals.saving-giftSaving-chugSaving;
        if(otherSavings)card.append(this.node('p','ws-gift__breakdown',this.t.other_saving+': '+this.money(otherSavings)));
        card.append(this.node('p','ws-gift__combined',this.t.saving+': '+this.money(totals.saving)));
        card.append(this.node('p','ws-gift__bundle',this.t.bundle));
        card.append(this.priceLine('',totals.regular,totals.saving));
        const add=this.node('button','ws-gift__add',this.t.add);add.type='button';add.dataset.giftAdd=String(item.id);add.setAttribute('aria-label',`${this.t.add}: ${this.cardTitle(item)}`);card.append(add);grid.append(card);
      });
    }
    collapse(hidden) {
      this.querySelector('[data-gift-main]').hidden=hidden;
      this.querySelector('[data-gift-reopen]').hidden=!hidden;
      try{sessionStorage.setItem(key,hidden?'yes':'no');}catch(_){}
    }
    handleClick(e) {
      const button=e.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-gift-category')) {
        this.group=button.dataset.giftCategory;
        this.querySelectorAll('[data-gift-category]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
        this.renderCards();
      }
      if(button.hasAttribute('data-gift-dismiss'))this.collapse(true);
      if(button.hasAttribute('data-gift-reopen'))this.collapse(false);
      if(button.hasAttribute('data-gift-more'))this.querySelector('[data-gift-picker]').hidden=false;
      if(button.hasAttribute('data-gift-add'))this.addCooler(button);
    }
    async addCooler(button) {
      if(CoolerGiftOffer.pending)return;
      CoolerGiftOffer.pending=true;
      const label=button.textContent;
      this.querySelectorAll('[data-gift-add]').forEach(el=>el.disabled=true);
      button.textContent=this.t.adding;
      this.querySelector('[data-gift-error]').textContent='';
      try {
        const id=Number(button.dataset.giftAdd);
        if(!this.catalog.some(item=>item.id===id))throw new Error('Invalid variant');

        const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1}],sections:['cart-drawer'],sections_url:location.pathname})});
        const data=await response.json();
        if(!response.ok)throw new Error(data.description || this.t.retry);
        try{sessionStorage.removeItem(key);}catch(_){}
        if(this.dataset.context==='page') {location.reload();return;}
        if(data.sections?.['cart-drawer'])window.eventBus.emit('update:cart:drawer',data);
        else window.eventBus.emit('render:cart:drawer');
        window.eventBus.emit('open:cart:drawer',{scrollToTop:true});
        const cartResponse=await fetch(window.Shopify.routes.root+'cart.js');
        if(cartResponse.ok)window.wetheme?.updateCartCount(await cartResponse.json());
      } catch(error) {
        if(this.isConnected)this.querySelector('[data-gift-error]').textContent=error.message || this.t.retry;
      } finally {
        CoolerGiftOffer.pending=false;
        if(this.isConnected) {this.querySelectorAll('[data-gift-add]').forEach(el=>el.disabled=false);button.textContent=label;}
      }
    }
  }
  if(!customElements.get('cooler-gift-offer'))customElements.define('cooler-gift-offer',CoolerGiftOffer);
})();
